import Refiner from 'refiner-js';

export const RefinerTracker = () => {
  Refiner('setProject', process.env.REACT_APP_REFINER_PROJECT_ID);
  return null;
};
